<template>
    <div>
        <form v-if="auth.screen === 'recovery2'" @submit.prevent="completeForgotPassword">
            <div class="row">
                <div class="col-12">
                    <h6>Forgot Password</h6>
                    <div class="form-group">
                        <div class="input-group">
                            <input id="token" v-model="model.token" type="number" minlength="4"  maxlength="4" class="form-input" required/>
                            <label class="input-label" for="token">
                                <span class="label-span">{{ $t('auth.otp')}}</span>
                            </label>
                        </div>
                        <p v-if="!model.token" class="input-error">OTP is required</p>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <div class="input-group">
                            <input id="password" v-model="model.password" minlength="6"  maxlength="6" type="password" class="form-input" required/>
                            <label class="input-label" for="password">
                                <span class="label-span">{{ $t('auth.password')}}</span>
                            </label>
                        </div>
                        <p v-if="!model.password" class="input-error">{{ $t('auth.passwordIsRequired')}}</p>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <div class="input-group">
                            <input id="confirmPassword" v-model="model.passwordConfirmation" minlength="6"  maxlength="6" type="password" class="form-input" required/>
                            <label class="input-label" for="confirmPassword">
                                <span class="label-span">{{ $t('extra.confirmPassword')}}</span>
                            </label>
                        </div>
                        <p v-if="!model.passwordConfirmation" class="input-error">Confirm Password Required</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <auth-base-button title="Submit" :loading="auth.authLoading"></auth-base-button>
                </div>
            </div>
        </form>
        <form v-else  @submit.prevent="forgotPassword">
            <div class="row">
                <div class="col-12">
                    <h6>Forgot Password</h6>
                    <div class="form-group">
                        <div class="input-group">
                            <input id="email" v-model="model.username" type="text" class="form-input" required/>
                            <label class="input-label" for="email">
                                <span class="label-span">username</span>
                            </label>
                        </div>
                        <p v-if="!model.username" class="input-error">{{ $t('auth.emailIsRequired')}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <auth-base-button title="Submit" :loading="auth.authLoading"></auth-base-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import AuthBaseButton from "../button/AuthBaseButton";
    export default {
        name: "LogonForm",
        components: {
            AuthBaseButton
        },
        data() {
            return {
                model: {
                    mobiledeviceid: '7162734443',
                    username: '',
                    requestid: '',
                    source: 'MOBILE',
                    devicedetails: '',
                    currentpassword: '',
                    uniqueref: '',
                    token: '',
                    password: '',
                    passwordConfirmation: '',
                    pin: ''
                },
            }
        },
        methods: {
            getRandomString(length) {
                let randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let result = '';
                for ( let i = 0; i < length; i++ ) {
                    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
                }
                return result;
            },

            clicked(){
                this.$swal({
                    title: 'Custom animation with Animate.css',
                    showClass: {
                        popup: 'animated slideInLeft faster display-6'
                    },
                    hideClass: {
                        popup: 'animated slideOutRight faster display-6'
                    },
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!'
                })
            },
            async forgotPassword() {
                console.log('this.getRandomString()>>>>>',this.getRandomString(30))
                this.model.requestid = this.getRandomString(30);
                await this.$store.dispatch("auth/initiateResetPassword", this.model, { root: false })
                this.model.uniqueref = this.auth.response.uniqueref
            },
            async completeForgotPassword() {
                if(this.model.password !== this.model.passwordConfirmation){
                    this.$swal('error', 'Password mismatched!')
                }else {
                    this.model.email = this.model.userEmail;
                    await this.$store.dispatch("auth/completeResetPassword", this.model, {root: false})
                    this.model = {
                        mobiledeviceid: '7162734443',
                        username: '',
                        requestid: '1006358033378444334444',
                        source: 'MOBILE',
                        devicedetails: '',
                        currentpassword: '',
                        uniqueref: '',
                        token: '',
                        password: '',
                        passwordConfirmation: '',
                        pin: ''
                    }
                }
            },
        },
        computed:{
            ...mapState([
                'company',
                'document',
                'auth',
                'officer',
            ]),
            minLength:function(){
                return this.model.password.length >= 8?'green':'red'
            },
            maxLength:function(){
                return this.model.password.length <= 13?'green':'red'
            },
            hasLettersNumbers:function(){
                return ( /[a-zA-Z]/g.test(this.model.password) && /[0-9]/g.test(this.model.password))?'green':'red'
            },
            hasSpecialXters:function(){
                return /[^a-zA-Z0-9]/g.test(this.model.password)?'green':'red'
            },
            hasLowerCase:function(){
                return /[a-z]/g.test(this.model.password)?'green':'red'
            },
            hasUpperCase:function(){
                return /[A-Z]/g.test(this.model.password)?'green':'red'
            },
            hasSpace:function(){
                return !(/\s/g.test(this.model.password))?'green':'red'
            },

        },

        watch: {
            'auth': function() {
                console.log('Hello World!')
            }
        },
        mounted() {
            // this.$store.auth.watch(this.$store.getters.getN, n => {
            //     console.log('watched: ', n)
            // })
        },
    }
</script>

<style scoped>

</style>
